import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TransactionsActionsState } from '../state/transactions-actions.state';

export const selectTransactionActionData =
    createFeatureSelector<TransactionsActionsState>('transactionActions');

export const selectTransactionActions = (transactionId: string) =>
    createSelector(
        selectTransactionActionData,
        (state: TransactionsActionsState) => state[transactionId]
    );
